
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/p/[slug]",
      function () {
        return require("private-next-pages/[lang]/p/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/p/[slug]"])
      });
    }
  